// Package imports
import React from 'react';

// CSS imports
import './AuthAccessWrapper.css';

// Type imports
import { User } from '../../../types/user/User';
import PrimaryButton from '../../../components/buttons/primaryButton/PrimaryButton';

type Props = {
  isInitialLoading: boolean;
  user: User | null;
  children: React.ReactNode;
  toggleLogin: () => void;
};

const AuthAccessWrapper: React.FC<Props> = ({
  isInitialLoading,
  user,
  children,
  toggleLogin,
}: Props) => {
  return (
    <>
      {isInitialLoading ? (
        <></>
      ) : user ? (
        children
      ) : (
        <div className='auth-access-denied'>
          <span className='denied-title'>Ups!</span>
          <span className='denied-text'>Please log in to view this page</span>
          <PrimaryButton label='Login' onClick={toggleLogin} />
        </div>
      )}
    </>
  );
};

export default AuthAccessWrapper;
